import FileSaver from 'file-saver';
import Mime from 'mime/lite';
import slugify from 'slugify';
import { ClipDataBuilder } from '../../../platform/Clipboard';
import { ExportValue } from './ExportDimension';

export interface ExportOutput {
    readonly type: string;
    readonly data: string;
}

const toClipData = (outputs: ExportOutput[]) => {
    const cdb = new ClipDataBuilder();
    for (const o of outputs) {
        cdb.setAsBlob(o.type, o.data);
    }
    return cdb.build();
};


const saveAs = (name: string, outputs: ExportOutput[]) => {
    // Select first non-plain/text format, otherwise fallback to first item (probably plain/text).
    const { data, type } = (outputs.find(x => x.type !== 'text/plain') ?? outputs[0]);
    // Generate file name as slug of name plus date
    const blob = new Blob([data], { type });
    const ext = Mime.getExtension(type);
    name = slugify(name);
    name = name.endsWith(ext) ? name : `${name}.${ext}`;
    FileSaver.saveAs(blob, name);
};

export const ExportOutput = Object.assign(
    (type: string, data: string) => ({ type, data }),
    { toClipData, saveAs }
);

export interface ExportFormat {

    readonly id: string;
    readonly label: string;
    readonly desc: string;

    apply(data: ExportValue[][]): ExportOutput[];
}
